import { Tutorial } from '@components/tutorial/Tutorial';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';
import { Step } from 'react-joyride';

export function ArsenalTutorial() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Tutorial.Inv' });
  const { tab, userData } = useAppStore();

  if (tab !== 'arsenal') return null;

  if (!userData.tutorials.includes('Upgrade') && userData.tutorials.includes('Combat')) {
    const steps: Step[] = [
      {
        target: '.arsenal-weapons',
        placement: 'center',
        content: t('invMod0'),
      },
      {
        target: '.weapon-button',
        content: t('invMod1'),
      },
    ];

    return <Tutorial tutorialKey="Upgrade" steps={steps} noSave />;
  }

  const steps: Step[] = [
    {
      target: '.arsenal-weapons',
      placement: 'center',
      content: t('inv0'),
    },
    {
      target: '.arsenal-weapons',
      placement: 'right',
      content: t('inv1'),
    },
    {
      target: '.arsenal-chassis',
      placement: 'right',
      content: t('inv2'),
    },
    {
      target: '.arsenal-mods',
      placement: 'right',
      content: t('inv3'),
    },
    {
      target: '.arsenal-forge',
      placement: 'right',
      content: t('inv4'),
    },
    {
      target: '.arsenal-items',
      placement: 'right',
      content: t('inv5'),
    },
    {
      target: '.arsenal-playerMarket',
      placement: 'right',
      content: t('inv6'),
    },
    {
      target: '.arsenal-market',
      placement: 'right',
      content: t('inv7'),
    },
    {
      target: '.nav-chat',
      placement: 'top',
      content: <p className="text-primary">{t('inv8')}</p>,
    }
  ];

  return <Tutorial tutorialKey="Inv" steps={steps} />;
}